module.exports = __webpack_public_path__ + "img/hunan.dfe41045.png";